import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        // primary: {
        //     main: '#1976d2', // Azul padrão MUI
        // },
        // secondary: {
        //     main: '#ff4081', // Rosa padrão MUI
        // },
        // background: {
        //     default: '#f4f6f8', // Cinza claro
        // },
        // text: {
        //     primary: '#212121',
        //     secondary: '#757575',
        // },
    },
    typography: {
        fontFamily: "VisbyCF-Regular, Arial, sans-serif",
        h1: {
            fontFamily: "VisbyCF-Bold",
            fontWeight: 700,
        },
        h2: {
            fontFamily: "VisbyCF-DemiBold",
            fontWeight: 600,
        },
        h3: {
            fontFamily: "VisbyCF-Medium",
            fontWeight: 500,
        },
        body1: {
            fontFamily: "VisbyCF-Regular",
            fontWeight: 400,
            color: '#fff'
        },
        body2: {
            fontFamily: "VisbyCF-Light",
            fontWeight: 300,
            color: '#fff'
        },
    },
});

export default theme;
